<template>
    <Drawer width="600" @on-close="closeDrawer" placement="right" :closable="false" v-model="values">
        <div class="page-title">
            <title-text :inline="true" :onlyText="false">{{ obj.title }}</title-text>
        </div>
        <Divider />
        <div class="drawer-content scrollbar">
            <Form ref="deptForm" :model="userInfo" autocomplete="off" class="padding-right-10" :rules="rules" label-position="left" :label-width="88">
                <FormItem label="用户类型" prop="userTypeSource">
                    <RadioGroup v-model="userInfo.userTypeSource">
                        <Radio v-for="item in userTypeList"
                               :label="item.val"
                               :key="'userType-' + item.label">{{ item.label }}</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="用户名" prop="loginName" :class="obj.type === 'edit' ? 'disabled-ele' : ''">
                    <Input v-model="userInfo.loginName" autocomplete="nope" :readonly="readOnly" @on-blur="checkTenant" @on-focus="readOnly = false" placeholder="请输入"></Input>
                </FormItem>
                <FormItem label="密码" :disabled="passwordDis" class="ivu-form-item-required" prop="password" v-if="(obj.type === 'create' && userInfo.userTypeSource !== '1')"  :show-message="showPwMessage">
                    <Input  v-model="userInfo.password" :disabled="passwordDis" autocomplete="nope" :readonly="pasWd" @on-focus="pasWd = false" :type="!pasWd ? 'password' : 'text'" placeholder="请输入"></Input>
                </FormItem>
                <FormItem label="所属机构" class="ivu-form-item-required" prop="deptId" :class="obj.type === 'create' ? 'disabled-ele' : ''">
                    <enc-tree ref="dropdownTree" :dropdown-select="true" :clearable="true" :inner-filter="true" value-key="id" label-key="deptName" v-model="userInfo.deptId" :data-array="obj.deptList"  title-name="deptName" @on-select-change="handleEditDepartSelect"></enc-tree>
                </FormItem>
                <FormItem label="角色" class="ivu-form-item-required" prop="roleList">
                    <div class="border-line min-height-20 cursor-point" style="width: 100%;padding: 0 10px;min-height: 30px" @click.stop="showRoleCom = !showRoleCom">
                        <Tag v-for="(item, index) in userInfo.roleList" closable  :key="item.id" @on-close="handleCloseTag(item, index)">{{ item.applicationName ? `${item.applicationName}-` : '' }}{{ item.roleName }}</Tag>
                    </div>
                    <RoleCom v-click-outside.stop="closeRoleCom" v-if="showRoleCom" :selectData="userInfo.roleList" :obj="roleObj" @closeDialog="closeRoleCom"></RoleCom>
                </FormItem>
                <Divider orientation="left" v-if="obj.attrList.length > 0"><span @click="showMores = !showMores"><Icon :type="showMores ? 'md-arrow-round-up' : 'md-arrow-round-down'"></Icon>更多</span></Divider>
                <div class="auto-form" v-if="showMores">
                    <template v-for="item in attrListGroup">
                        <FormItem v-if="item.enable" :label="item.name" :key="item.id" :prop="item.code" :class="item.enable && item.required ? 'ivu-form-item-required' : ''">
                            <template v-if="item.code === 'sex'">
                                <RadioGroup v-model="item.value" @on-change="resetCheck(item.code)">
                                    <Radio v-for="item in genderList"
                                           :label="item.val"
                                           :key="'userType-' + item.label">{{ item.label }}</Radio>
                                </RadioGroup>
                            </template>
                            <template v-else-if="(item.code === 'staffPhoto' || item.code === 'signature')">
                                <UploadImg :url="imgUrlList[item.code]"
                                           :token="token"
                                           :name="item.code"
                                           :isSingle="item.code === 'signature'"
                                           :data="item.code === 'staffPhoto' ? (item.value ? [item.value] : []) : item.value || []"
                                           @handleView="handleView"
                                           @handleRemove="handleRemove"
                                           @handleSuccess="handleSuccess"
                                ></UploadImg>
                            </template>
                            <template v-else>
                                <Input :type="getInputType(item.code)" v-model="item.value" placeholder="请输入" @on-blur="checkField(item.code)"></Input>
                            </template>
                        </FormItem>
                    </template>
                </div>
            </Form>
        </div>
        <div class="drawer-footer">
            <Button class="margin-lr-20" @click="closeDrawer">取消</Button>
            <Button type="primary" @click.native.stop="confirmDrawer('deptForm')">确定</Button>
        </div>
        <Modal title="查看图片" v-model="visibleImg">
            <img class="img-cover" :src="curImg" width="100%">
        </Modal>
    </Drawer>
</template>

<script>
import EncTree from '../../../components/EncTree.vue'
import UploadImg from './uploadImg.vue'
import common from '../../../common/common'
import utils from '../../../common/utils'
import RoleCom from './roleCom.vue'
import api from '../../../common/api'

export default {
    name: 'CreateUpdateUserInfo',
    props: {
        obj: {
            type: Object,
            required: true
        }
    },
    computed: {
        attrList() {
            return this.obj.attrList
        }
    },
    watch: {
        // eslint-disable-next-line func-names
        'obj.attrList': {
            handler() {
                this.attrListGroup = JSON.parse(JSON.stringify(this.obj.attrList))
                const validate = (rule, value, callback) => {
                    const curVal = this.attrListGroup.filter((item) => item.code === rule.field)
                    console.log('gg====', curVal, rule)
                    if (!curVal || curVal.length < 1 || !curVal[0].value) {
                        return callback(new Error(`${curVal[0].name}不能为空`))
                    }
                    const pattern = new RegExp(curVal[0].matchRule)
                    if (curVal[0].matchRule && !(pattern.test(curVal[0].value))) {
                        return callback(new Error(`${curVal[0].name}格式不正确`))
                    }
                    return callback()
                }
                this.obj.attrList.forEach((item) => {
                    if (item.enable && item.required) {
                        this.rules[item.code] = [{
                            validator: validate, trigger: 'blur'
                        }]
                    }
                    this.rules[item.code] = item.matchRule ? [{
                        pattern: item.matchRule, message: `${item.name}格式不正确`
                    }] : []
                })
                if (this.obj.type === 'edit') {
                    this.initUserInfo()
                }
            },
            deep: true
        },
        // eslint-disable-next-line func-names
        'obj.isShow': function (val) {
            this.showMores = false
            this.$refs.deptForm.resetFields()
            this.values = val
            if (this.obj.type === 'create') {
                Object.assign(this.$data.userInfo, this.$options.data().userInfo)
            }
            this.curDept = this.obj.dept
            this.userInfo.deptId = this.obj.dept.id
            this.passwordDis = false
        }
    },
    components: {
        UploadImg,
        RoleCom,
        EncTree
    },
    data() {
        const validateDept = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('所属机构不能为空'))
            }
            return callback()
        }
        const validateRole = (rule, value, callback) => {
            if (!value || value.length < 1) {
                return callback(new Error('角色不能为空'))
            }
            return callback()
        }
        return {
            showRoleCom: false,
            showMores: false,
            values: false,
            readOnly: true,
            pasWd: true,
            type: 'text',
            token: '',
            curImg: '',
            showIcome: false,
            visibleImg: false,
            loginUserInfo: {},
            passwordDis: false,
            showPwMessage: '',
            imgUrlList: {
                staffPhoto: 'api/auth/v1/file/upload',
                signature: '/api/auth/v1/file/batch_upload'
            },
            roleObj: {
                appList: [],
                choiceData: []
            },
            userTypeList: [{
                label: '普通用户',
                val: '0'
            }],
            genderList: [{
                label: '男',
                val: '0'
            }, {
                label: '女',
                val: '1'
            }],
            staffData: null,
            rules: {
                deptId: [
                    { validator: validateDept, trigger: 'blur' }
                ],
                userTypeSource: [
                    { required: true, message: '用户类型不能为空', trigger: 'blur' }
                ],
                loginName: [
                    { required: true, message: '用户名不能为空', trigger: 'blur' },
                    { pattern: /^[0-9a-zA-Z]+$/, message: '用户名必须字母或数字' },
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ],
                roleList: [
                    { validator: validateRole, trigger: 'blur' }
                ]
            },
            curDept: {
                id: ''
            },
            attrListGroup: [],
            userInfo: {
                userTypeSource: '0',
                loginName: '',
                password: '',
                org: '',
                deptId: '',
                cnName: '',
                gender: '',
                roleList: []
            }
        }
    },
    created() {
        this.getAppList()
        this.showIcome = window.globalConfig.showIcome
        if (this.showIcome) {
            this.userTypeList.push({
                label: 'icome用户',
                val: '1'
            })
        }
    },
    mounted() {
        this.loginUserInfo = common.getLoginUserInfo();
        this.token = common.getLocalToken()
    },
    methods: {
        getInputType(code) {
            let type = ''
            switch (code) {
            case 'mobile':
                type = 'tel'
                break;
            case 'email':
                type = 'email'
                break;
            default:
                type = 'text'
            }
            return type
        },
        checkTenant() {
            if (!this.userInfo.loginName) {
                return
            }
            this.passwordDis = false
            api.checkUserExit({
                loginName: this.loginUserInfo.loginName,
                master: this.loginUserInfo.isMaster,
                tenantId: this.loginUserInfo.userId,
                userName: this.userInfo.loginName
            }).then((res) => {
                if (res.data && res.data.messageType !== '0') {
                    this.$Message.warning(res.data.message)
                    this.passwordDis = Number(res.data.messageType) === 1
                    this.pasWd = !this.passwordDis
                    this.userInfo.password = this.passwordDis ? '1111111' : ''
                    // eslint-disable-next-line no-unused-expressions
                    this.passwordDis ? this.$refs.deptForm.validateField('password') : null
                } else {
                    this.userInfo.password = ''
                }
            })
        },
        resetCheck(type) {
            this.$refs.deptForm.validateField(type)
        },
        initUserInfo() {
            const roleName = this.obj.userInfo?.roleName?.split(',')
            const roleList = this.obj.userInfo.roleId.map((item, index) => ({ id: item, roleName: roleName[index] }))
            this.attrListGroup.forEach((item) => {
                item.value = (this.obj.userInfo.userInfo[0] || {})[item.code]
            })
            this.userInfo = { ...this.obj.userInfo, ...{ roleList } }
        },
        requestOptUser(apiCb, closeCb) {
            const userInfo = {}
            const password = this.obj.type === 'create' && !this.passwordDis ? { password: this.userInfo.password } : {}
            this.attrListGroup.forEach((item) => {
                userInfo[item.code] = item.value
            })
            const params = {
                deptId: this.curDept?.id,
                loginName: this.userInfo.loginName,
                roleId: this.userInfo.roleList.map((item) => item.id),
                userTypeSource: this.userInfo.userTypeSource,
                id: this.userInfo.id,
                userInfo,
                ...password
            }
            apiCb(params).then((res) => {
                const succCb = () => {
                    closeCb()
                    this.$Message.success(this.obj.type === 'edit' ? '编辑成功' : '新增成功')
                    this.$emit('refreshPage')
                }
                const errCb = () => {
                    this.$Message.error(res.resultMessage)
                }
                utils.resSucFactory(res, succCb, errCb)
            })
        },
        addEditUser(apiCb, closeCb) {
            this.$refs.deptForm.validate((valid) => {
                if (valid) {
                    this.requestOptUser(apiCb, closeCb)
                } else {
                    console.log('error==========')
                }
            })
        },
        getAppList(condition) {
            api.getAppLists({ condition }).then((res) => {
                this.roleObj.appList = res.data
            })
        },
        handleEditDepartSelect(selections, node) {
            this.userInfo.deptId = node?.id
            this.curDept = node
        },
        handleCloseTag(item, index) {
            this.userInfo.roleList.splice(index, 1)
        },
        closeDrawer() {
            this.$emit('closeTip')
        },
        confirmDrawer() {
            if (this.obj.type === 'create') {
                this.addEditUser(api.addUser, this.closeDrawer)
                return
            }
            this.addEditUser(api.editUser, this.closeDrawer)
        },
        handleView(name) {
            this.curImg = name
            this.visibleImg = true
        },
        handleRemove(item, index, type) {
            if (type === 'staffPhoto') {
                // eslint-disable-next-line no-shadow
                this.attrListGroup.filter((item) => item.code === 'staffPhoto')[0].value = ''
                return
            }
            // eslint-disable-next-line no-shadow
            this.attrListGroup.filter((item) => item.code === 'signature')[0].value.splice(index, 1)
        },
        handleSuccess(res, type) {
            const staffCb = () => {
                this.attrListGroup.filter((item) => item.code === 'staffPhoto')[0].value = res.data
            }
            const userPhotoCb = () => {
                if (!this.obj.attrList.filter((item) => item.code === 'signature')[0].value) {
                    this.attrListGroup.filter((item) => item.code === 'signature')[0].value = []
                }
                this.attrListGroup.filter((item) => item.code === 'signature')[0].value.push(res.data.split(';')[0])
            }
            if (res.resultCode === 0) {
                // eslint-disable-next-line no-unused-expressions
                type === 'staffPhoto' ? staffCb() : userPhotoCb()
            }
            this.resetCheck(type)
        },
        closeRoleCom(type, data) {
            this.showRoleCom = false
            if (type === 'cancel' || !type || type !== 'confirm') { return }
            this.userInfo.roleList = data
            this.$refs.deptForm.validateField('roleList')
        },
        checkField(code) {
            console.log('========', code)
            this.$refs.deptForm.validateField(code)
        }
    }
}
</script>

<style lang="less" scoped>
    .min-height-20 {
        min-height: 20px;
    }
    .drawer-footer {
        width: 100%;
        position: absolute;
        background: #ffffff;
        border-top: 1px solid #e8e8e8;
        bottom: 0;
        left: 0;
        padding: 10px 16px;
        text-align: right;
    }
    .drawer-content {
        height: calc(100% - 130px);
        overflow-y: scroll;
    }
    .border-line {
        border-radius: 4px;
        border: 1px solid var(--divider-color);
    }
    .role-icon {
        position: relative;
        top: 2px;
    }
    .padding-right-10 {
        padding-right: 10px;
    }
    /deep/ .ivu-divider-inner-text{
        color: var(--comp-selected-color);
        cursor: pointer;
    }
</style>
